module.exports = __webpack_public_path__ + "static/South-Africa-65e6e2f0d69fe893a9a2a816c8cea58f.jpg";